<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { todoComputed, todoMethods } from '@/state/helpers'
// import jwt_decode from 'jwt-decode'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // isShow : false
    }
  },

  computed: {
    ...todoComputed,
    // ...Helper,
    /**
     * Total no. of records
     */

    title() {
      return this.$t('master.dataMaster')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
    // getAccessFunc,
    /**
     *
     * @returns
     *
     */
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ $t('master.dataMaster') }}</span>
            </template>
            <b-row class="mc-card__list">

              <b-col
                v-if="
                  this.getAccessFunc('masterTracker') ||
                  hasAccess([
                    'sms-md-device:create',
                    'sms-md-device:read',
                    'sms-md-device:update',
                    'sms-md-device:delete',
                  ])
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Tracking' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_radio"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.tracker') }}</h4>
                    <p>{{ $t('master.textTracker') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="
                  this.getAccessFunc('masterUser') ||
                  hasAccess([
                    'sms-md-user:create',
                    'sms-md-user:read',
                    'sms-md-user:update',
                    'sms-md-user:delete',
                  ])
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master User' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.users') }}</h4>
                    <p>{{ $t('master.textUser') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                v-if="
                  hasAccess([
                    'sms-md-vehicle:create',
                    'sms-md-vehicle:read',
                    'sms-md-vehicle:update',
                    'sms-md-vehicle:delete',
                  ]) && $store.state.config.vehicleType
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Fleet Type' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_truck-bak"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('vehicle.status.vehicleType') }}</h4>
                    <p>{{ $t('master.textVehicleType') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                v-if="
                  hasAccess([
                    'sms-device-multi-imei:create',
                    'sms-device-multi-imei:read',
                    'sms-device-multi-imei:update',
                    'sms-device-multi-imei:delete',
                  ])
                "
                md="6"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Master Multi Imei' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_truck-bak"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('master.vehicle.multiImei.title') }}</h4>
                    <p>{{ $t('master.vehicle.multiImei.description') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
